import { ChatIcon, MuteIcon, SoundIcon } from "assets/icons";
import { SOUNDS } from "assets/sounds";
import { useBoolean, useLocalStorage } from "hooks";
import { SocketsContext } from "libs/soket";
import { useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { IconButton } from "ui";

import styles from "./ChatWidget.module.scss";

const NEW_MESSAGE_ALERT_INTERVAL = 30000;

const HIDDEN_ROUTES = ["/ai/conversations", "/ai/support"];

const ChatWidget = () => {
  const { pathname } = useLocation();
  const [isMuted, setIsMuted] = useLocalStorage("chat-widget-muted", false);
  const { chatSocket } = useContext(SocketsContext);
  const {
    value: isNewMessageIndicatorVisible,
    setTrue: showNewMessageIndicator,
    setFalse: hideNewMessageIndicator
  } = useBoolean(false);

  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    showNewMessageIndicator();

    timerRef.current = setTimeout(() => {
      hideNewMessageIndicator();
    }, NEW_MESSAGE_ALERT_INTERVAL);
  };

  useEffect(() => {
    if (chatSocket.socket) {
      chatSocket.socket?.on("helpcrunch-new-customer-message", () => {
        resetTimer();
      });
    }

    return () => {
      chatSocket?.socket?.off("helpcrunch-new-customer-message");
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [chatSocket.socket]);

  useEffect(() => {
    if (isNewMessageIndicatorVisible && !isMuted) {
      SOUNDS.NEW_MESSAGE_IN_SUPPORT_CHAT.play();
    }
  }, [isNewMessageIndicatorVisible]);

  if (HIDDEN_ROUTES.some((route) => pathname.startsWith(route))) {
    return null;
  }

  return (
    <div className={styles.chatWidgetContainer}>
      <a
        href="https://chapshop.helpcrunch.com/v2/chats"
        target="_blank"
        rel="noreferrer"
        className={styles.widget}
      >
        <ChatIcon />

        {isNewMessageIndicatorVisible && (
          <div className={styles.newMessageIndicator} />
        )}
      </a>

      <div className={styles.widget_muteButton}>
        <IconButton
          icon={
            !isMuted ? (
              <SoundIcon width={18} height={18} />
            ) : (
              <MuteIcon width={18} height={18} />
            )
          }
          onClick={() => {
            setIsMuted(!isMuted);
          }}
        />
      </div>
    </div>
  );
};

export default ChatWidget;
